import { render } from "./Add.vue?vue&type=template&id=3c3e9ee8"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Tasks/Add.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c3e9ee8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c3e9ee8', __exports__)) {
    api.reload('3c3e9ee8', __exports__)
  }
  
  module.hot.accept("./Add.vue?vue&type=template&id=3c3e9ee8", () => {
    api.rerender('3c3e9ee8', render)
  })

}


export default __exports__